import { createSlice, createListenerMiddleware } from '@reduxjs/toolkit'

const STORAGE_KEY = 'mealPlanState';

const getInitialState = () => {
  const saved = localStorage.getItem(STORAGE_KEY);
  if (saved) {
    try {
      return JSON.parse(saved);
    } catch {
      return { showAllCategories: false, lastViewedDate: null };
    }
  }
  return { showAllCategories: false, lastViewedDate: null };
};

const mealPlanSlice = createSlice({
  name: 'mealPlan',
  initialState: getInitialState(),
  reducers: {
    setShowAllCategories(state, action) {
      state.showAllCategories = action.payload;
    },
    setLastViewedDate(state, action) {
      state.lastViewedDate = action.payload;
    },
  },
})

const persistenceListener = createListenerMiddleware();

persistenceListener.startListening({
  predicate: (action) => action.type.startsWith('mealPlan/'),
  effect: (action, listenerApi) => {
    const state = listenerApi.getState();
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state.mealPlan));
  }
});

export const { setShowAllCategories, setLastViewedDate } = mealPlanSlice.actions
export default mealPlanSlice.reducer
export const persistenceMiddleware = persistenceListener.middleware

